export const tw = {
  'enter_editing': '進入編輯',
  'exam_list': '題組列表',
  '720_editor': '環景編輯',
  'logout': '登出',
  'add_exam': '新增題組',
  'import_exam': '匯入題組',
  'welcome': '歡迎登入',
  'delete': '刪除',
  'modify': '修改',
  'demo': '預覽',
  'copy': '複製',
  'confirm': '確定',
  'cancel': '取消',
  'next': '下一步',
  'previous': '上一步',
  'finish': '完成',
  'default': '預設',
  'account': '帳號',
  'password': '密碼',
  'exam_name': '題組名稱',
  'exam_quantity': '題組數量',
  'exam': '題目',
  'exam_type': '題目類型',
  'option': '選項',
  'answer': '答案',
  'back': '回列表',
  'login': '登入',
  'multiple_selection': '多選題',
  'multiple_choice': '單選題',
  'fillIn_name': '請填寫題組名稱',
  'fillIn_option': '請填寫選項',
  'fillIn_exam': '請填寫題目'

}
